export const getBasicDetails = (profile, lifestyleMap = {}) => [
  { label: "First Name", value: profile?.basic?.first_name || "" },
  { label: "Last Name", value: profile?.basic?.last_name || "" },
  { label: "Marital status", value: profile?.basic?.marital_status || null },
  { label: "Religion", value: profile?.basic?.religion || null },
  { label: "Community", value: profile?.basic?.sub_religion || null },
  { label: "Gender", value: profile?.basic?.gender || null },
  { label: "Nationality", value: profile?.basic?.country || null },
  { label: "Mother Tongue", value: profile?.basic?.mother_tongue || null },
  { label: "Language", value: profile?.basic?.language || null },
  { label: "Date of Birth", value: profile?.basic?.dob || "" },
  { label: "Location", value: profile?.basic?.custom_location || null },
  { label: "Grew up in", value: profile?.basic?.city || "" },
  { label: "Diet", value: profile?.basic?.diet || null },
  {
    label: "Smoking",
    value: profile?.basic?.smoke || null,
  },
  {
    label: "Drinking",
    value: profile?.basic?.drink || null,
  },
  {
    label: "Interested in moving abroad",
    value: profile?.basic?.interested_in_moving_abroad ?? null,
  },
];

export const getCurrentLocationDetails = (profile) => [
  {
    label: "Country",
    value: profile?.current_location?.country_living || null,
  },
  { label: "State", value: profile?.current_location?.state || null },
  { label: "District", value: profile?.current_location?.district || null },
  { label: "Town", value: profile?.current_location?.town || null },
  { label: "Pincode", value: profile?.current_location?.pincode || "" },
];

export const getPermanentAddressDetails = (profile) => [
  { label: "Country", value: profile?.permanent_location?.country || null },
  { label: "State", value: profile?.permanent_location?.state || null },
  { label: "District", value: profile?.permanent_location?.district || null },
  { label: "Town", value: profile?.permanent_location?.town || null },
  { label: "Pincode", value: profile?.permanent_location?.pincode || "" },
];
